<template>
  <div>
    <div class="d-flex justify-content-between">
      <h1 class="page-header">
        {{ $t('administration.company.company') }}
      </h1>
      <ts-breadcrumb
        :items="[
          { text: $t('toHomePage'), href: '/' },
          { text: $t('administration.company.company'), active: true }
        ]"
      />
    </div>
    <ts-card>
      <ts-card-wrapper>
        <div class="row">
          <div class="col-sm-4">
            <!-- <ts-button
                  color="info"
                  outline
                  @click="$router.push({ name: 'company-create' })"
                >
                  {{ $t('administration.company.add_new') }}
                </ts-button> -->
          </div>
          <div class="col-sm-8 d-flex justify-content-end">
            <ts-input
              v-model="search"
              :placeholder="$t('administration.company.search')"
              style="width: 300px"
            />
          </div>
        </div>
      </ts-card-wrapper>
      <div class="overflow-auto">
        <ts-loading-banner :loading="exporting">
          <Table
            :columns="columns"
            :data="resources"
            :loading="loading"
            max-height="700"
            stripe
            highlight-row
            size="small"
          >
            <template slot-scope="{ row }" slot="action">
              <a
                href="#"
                class="mr-2 text-primary"
                @click.prevent="edit(row)"
                v-tooltip="$t('administration.company.edit')"
              >
                <i class="fas fa-edit"></i>
              </a>
              <a
                href="#"
                class="text-danger"
                @click.prevent="destroyCompany(row)"
                :disabled="row._deleting"
                v-tooltip="$t('administration.company.delete')"
              >
                <i class="fas fa-circle-notch spin" v-if="row._deleting"></i>
                <i class="fas fa-trash" v-else></i>
              </a>
            </template>
          </Table>
        </ts-loading-banner>
      </div>
      <div class="d-flex justify-content-between align-items-center p-15">
        
        <ts-pagination
          v-model="pagination"
          @navigate="fetchData"
        ></ts-pagination>
      </div>
    </ts-card>
  </div>
</template>
<script>
import { debounce } from 'lodash'
import { mapState } from 'vuex'
export default {
  name: 'company',
  data () {
    return {
      loading: false,
      exporting: false
    }
  },
  created () {
    this.fetchData()
  },
  computed: {
    ...mapState('company', ['resources', 'pagination']),
    search: {
      get () {
        return this.$store.state.company.search
      },
      set (newValue) {
        this.$store.commit('company/SET_SEARCH', newValue)
        this.$store.commit('company/RESET_CURRENT_PAGE')
      }
    },
    columns () {
      return [
        {
          title: this.$t('administration.company.code'),
          key: 'company_code',
          minWidth: 60
        },
        {
          title: this.$t('administration.company.name_kh'),
          key: 'company_name_kh',
          minWidth: 80
        },
        {
          title: this.$t('administration.company.name_en'),
          key: 'company_name_en',
          minWidth: 80
        },
        {
          title: this.$t('administration.company.prefix'),
          key: 'prefix',
          minWidth: 80
        },
        {
          title: this.$t('administration.company.phone'),
          key: 'phone',
          minWidth: 80
        },
        {
          title: this.$t('administration.company.email'),
          key: 'email',
          minWidth: 80
        },
        {
          title: this.$t('administration.company.facebook_page'),
          key: 'facebook_page',
          minWidth: 80
        },
        {
          title: this.$t('administration.company.web_site'),
          key: 'website',
          minWidth: 80
        },
        {
          title: this.$t('actions'),
          key: 'action',
          slot: 'action',
          fixed: 'right',
          align: 'center',
          width: 100
        }
      ]
    }
  },
  methods: {
    fetchData (attributes) {
      this.loading = true
      this.$store
        .dispatch('company/fetch', attributes)
        .then(response => {
          this.loading = false
        })
        .catch(error => {
          this.loading = false
          this.$toasted.error(error.message)
        })
    },
    edit (record) {
      this.$store.commit('company/SET_EDIT_DATA', record)
      this.$router.push({
        name: 'company-edit',
        params: { id: record.company_id }
      })
    },
    async destroyCompany (record) {
      if (
        await this.$confirmModal.danger(
          this.$t('administration.company.are_you_sure_to_delete')
        )
      ) {
        record._deleting = true
        this.$store
          .dispatch('company/destroy', record.company_id)
          .then(response => {
            this.fetchData()
            this.$toasted.success(response.message)
            record._deleting = false
          })
          .catch(error => {
            this.$toasted.error(error.message)
            record._deleting = false
          })
      }
    }
  },
  watch: {
    search: debounce(function (search) {
      this.fetchData({ search })
    }, 500)
  },
  beforeRouteLeave (to, from, next) {
    if (_.isEmpty(to.params) && to.name != 'company-create') {
      this.$store.commit('company/RESET_STATE')
    }
    next()
  }
}
</script>
